export default {
	readConfirmations: {
		seen: 'Gelesen',
		seenBy: 'Gelesen von',
		collectedSinceHint:
			'Die Lesebestätigungen für Dokumente werden seit Version 04.2026 erfasst. Ältere Lesevorgänge sind nicht enthalten.',
		noReadConfirmations: 'Noch keine Lesebestätigungen vorhanden.',
	},
}
